import {Component} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {DateUtilsService} from "../../../../shared/services/dateUtils.service";
import {UpdatePasswordService} from '../service/update-password.service';
import {MatDialog} from '@angular/material/dialog';
import {lastValueFrom} from 'rxjs';
import {LoadingService} from "../../../../core/services/loading.service";


@Component({
  selector: 'app-check-your-email',
  templateUrl: './check-your-email.component.html',
  styleUrls: ['./check-your-email.component.scss'],
})
export class CheckYourEmailComponent {
  public errMessage: string | null;

  disableResend = true;
  delayInMinutes = 1;
  allowResendTime = new Date();

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private service: UpdatePasswordService,
    private dialogService: MatDialog,
    public loader: LoadingService,
    public dateUtils: DateUtilsService
  ) {
    this.errMessage = null;
    this.resendDelay();
  }

  onSubmit(): void {
    this.router.navigate([`/forgot-password/password-reset`]);
  }

  resendDelay() {
    this.disableResend = true;
    const delay = this.delayInMinutes * 60 * 1000;
    this.allowResendTime = new Date(Date.now() + delay);
    setTimeout(() => {
      this.disableResend = false;
    }, delay);
  }

  onResendOTP(): void {
    lastValueFrom(this.service.requestNewOTP(true))
      .then(
        (res) => {
          this.resendDelay();
          this.dialogService.open(HTMLDialogElement, {
            height: '300px',
            width: '475px',
            data: {
              header: 'Resend OTP',
              description: 'We have sent a One Time Pin to the provided email.',
              imageSrc: '../../../../assets/icon-verification-dark.svg'
            },
          });
        },
        (err) => {
          switch (err.status) {
            case 400:
              if ('ValidationException' === err.headers.get('error_code')) {
                this.errMessage = '' + err.headers.get('error_message');
              }
              break;
            default:
              console.log(err);
              this.dialogService.open(HTMLDialogElement, {
                height: '300px',
                width: '450px',
                data: {
                  header: 'Oops!',
                  description: 'An unexpected error occurred',
                },
              });
          }
        }
      );
  }
}
